// extracted by mini-css-extract-plugin
var _1 = "ActivityPostCard-module__animateUploadProgressBarWidth--MSmGP";
var _2 = "ActivityPostCard-module__animatedBackground--VLCny";
var _3 = "ActivityPostCard-module__footer--UVlR8";
var _4 = "ActivityPostCard-module__seriesContainer--Xb27R";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "footer", _4 as "seriesContainer" }
